// ArgyleBankReturnPage.tsx
//
// Landing page for the Finicity Connect redirect-back URL.
//
// Flow:
//   1. User clicks "Continue with Argyle" on the Employment Income page.
//   2. useArgyleIncomeWorkflow stores window.location.href in sessionStorage
//      under 'argyle_bank_return_origin' then calls window.location.assign
//      with the Finicity Connect URL.
//   3. After the user connects their bank, Finicity redirects back to:
//        <ARGYLE_BANK_REDIRECT_URL>?trn_id=<id>
//      which maps to this page at /argyle-bank-return.
//   4. This page reads the stored origin and navigates back immediately.
//      The bank income section on the document analysis page handles status
//      polling via ArgyleBankIncomeSection — no polling needed here.
import React, { useEffect } from 'react';
import { ARGYLE_BANK_PENDING_HINT_PREFIX } from '../utils/argyleConfig';

const ArgyleBankReturnPage: React.FC = () => {
  useEffect(() => {
    const returnOrigin = sessionStorage.getItem('argyle_bank_return_origin');
    sessionStorage.removeItem('argyle_bank_return_origin');
    const trnId = new URLSearchParams(window.location.search).get('trn_id');
    if (trnId) {
      sessionStorage.setItem(
        `${ARGYLE_BANK_PENDING_HINT_PREFIX}${trnId}`,
        String(Date.now())
      );
    }

    if (returnOrigin) {
      window.location.assign(returnOrigin);
    } else {
      // Fallback: no stored origin (direct navigation, different tab, etc.)
      window.location.assign('/');
    }
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        fontFamily: 'sans-serif',
        color: '#334155',
      }}
    >
      <p>Bank account connected. Redirecting back…</p>
    </div>
  );
};

export default ArgyleBankReturnPage;
